import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { realestateCategoryOptions } from '@app/forms/subscription/services/ref';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'real-estate-lmplmnpparameters',
    templateUrl: './real-estate-lmplmnpparameters.component.html',
    styleUrls: ['./real-estate-lmplmnpparameters.component.scss'],
    standalone: false
})
export class RealEstateLMPLMNPParametersComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  realestateCategoryOptions = realestateCategoryOptions;
  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
